import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { ExportProvider } from 'context/exportContext';
import { DashboardWrapper } from './DashboardWrapper';

export const MyView = () => {
	return (
		<ExportProvider>
			<DashboardWrapper />
		</ExportProvider>
	);
};
